import { PaymentType } from '@/types/payment';
import { PaymentGroupType } from '@/types/payment-groups';
import { usePaymentsList } from '../../hooks/usePaymentsList';
import { PaymentPageTab } from '../../types';
import { PaymentsListContent } from '../PaymentsListContent';

type ListPaymentsToPayTabProps = {
  paymentType?: PaymentType;
  paymentGroupType?: PaymentGroupType;
};

export function ListPaymentsToPayTab(opts: ListPaymentsToPayTabProps) {
  const paymentsListData = usePaymentsList({
    paymentGroupType: opts.paymentGroupType,
    paymentType: opts.paymentType,
    tab: PaymentPageTab.TO_PAY,
  });

  return (
    <PaymentsListContent {...paymentsListData} tab={PaymentPageTab.TO_PAY} />
  );
}
